// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","1262":"6b0f4642","1889":"6b0f4642","2125":"f97b4970","3502":"554f9e6b"}[chunkId] + ".chunk.css";
};